/* eslint-disable no-undef */

document.getElementsByClassName('js-windows-top')[0].addEventListener('click', () => {
    dataLayer.push({
        event: 'analyticsEvent',
        eventCategory: 'Click',
        eventAction: 'Download',
        eventLabel: 'Windows',
    });
});
document.getElementsByClassName('js-windows-bottom')[0].addEventListener('click', () => {
    dataLayer.push({
        event: 'analyticsEvent',
        eventCategory: 'Click',
        eventAction: 'Download',
        eventLabel: 'Windows',
    });
});

document.getElementsByClassName('js-mac-top')[0].addEventListener('click', () => {
    dataLayer.push({
        event: 'analyticsEvent',
        eventCategory: 'Click',
        eventAction: 'Download',
        eventLabel: 'Mac',
    });
});

document.getElementsByClassName('js-mac-bottom')[0].addEventListener('click', () => {
    dataLayer.push({
        event: 'analyticsEvent',
        eventCategory: 'Click',
        eventAction: 'Download',
        eventLabel: 'Mac',
    });
});



// WEBPACK FOOTER //
// ./src/js/methods/analytics.js